// extracted by mini-css-extract-plugin
module.exports = {"container":"VolumeControls_container__2DGII","volumeIcon":"VolumeControls_volumeIcon__2JuCB"};